import { Component, inject, Input } from "@angular/core";
import { ControlContainer, ReactiveFormsModule } from "@angular/forms";
import { UiKitModule } from "@app/ui-kit.module";
import { FormFieldComponent } from "@odx/angular/components/form-field";

@Component({
  selector: "app-draeger-contact-person-form-field",
  imports: [FormFieldComponent, UiKitModule, ReactiveFormsModule],
  templateUrl: "./draeger-contact-person-form-field.component.html",
  viewProviders: [
    {
      provide: ControlContainer,
      useFactory: (): ControlContainer => inject(ControlContainer, { skipSelf: true }),
    },
  ],
  standalone: true,
})
export class DraegerContactPersonFormFieldComponent {
  @Input() isReadonly!: boolean;
  @Input() required!: boolean;
}
